import { I18n } from 'aws-amplify/utils';

export const putGermanVocabulary = () => {
    I18n.setLanguage("de");

    const dict = {
        "de": {
            "Sign in to your account": "Login",
            "Sign in": "Anmelden",
            "Username *": "Benutzername *",
            "Password *": "Passwort *",
            "Password": "Passwort",
            "Enter your Username": "Geben Sie Ihren Benutzernamen ein",
            "Enter your Password": "Geben Sie Ihr Passwort ein",
            "Forgot your password?": "Passwort vergessen?",
            "Password is hidden": "Passwort ist versteckt",
            "Reset password": "Passwort zurücksetzen",
            "No account?": "Kein Benutzerkonto?",
            "Create account": "Benutzerkonto erstellen",
            "Username cannot be empty": "Username darf nicht leer sein.",
            "Password cannot be empty": "Passwort darf nicht leer sein.",
            "Incorrect username or password.": "Benutzername oder Passwort falsch.",
            "Reset your password": "Passwort zurücksetzen",
            "Back to Sign In": "Zurück zum Login",
            "Send Code": "Code zusenden",
            "User does not exist.": "Benutzer existiert nicht.",
            "Sign Out": "Abmelden",
            "Change Password": "Passwort ändern",
            "New password": "Neues Passwort",
            "Email Address": "E-Mail",
            "Change": "Ändern",
            "Verification code": "Bestätigungscode",
            "Enter code": "Code eingeben",
            "Submit": "Senden",
            "Account recovery requires verified contact information": "Verifizieren Sie bitte den Account",
            "Password does not conform to policy: Password not long enough": "Passwort ist nicht lang genug.",
            "Skip": "Überspringen",
            "Verify": "Verifizieren",
            "Invalid verification code provided, please try again.": "Ungültiger Verifizierungscode, bitte probieren sie es nochmals."
        }
    }

    I18n.putVocabularies(dict);
}
